
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.94 13.76c-1.547 0-3.083-.37-4.61-1.11a14.984 14.984 0 01-4.09-2.91c-1.2-1.2-2.17-2.56-2.91-4.08C.59 4.14.22 2.6.22 1.04.22.8.3.6.46.44.62.28.82.2 1.06.2h2.6a.836.836 0 01.84.68l.46 2.36c.027.2.02.38-.02.54-.04.16-.127.3-.26.42L2.84 6a14.502 14.502 0 005.24 5.16l1.78-1.8c.133-.133.29-.227.47-.28.18-.053.363-.067.55-.04l2.22.46c.2.04.363.133.49.28.127.147.19.327.19.54v2.6c0 .24-.08.44-.24.6-.16.16-.36.24-.6.24zM2.28 4.86L3.7 3.5a.177.177 0 00.05-.09.137.137 0 00-.01-.09l-.34-1.8a.182.182 0 00-.06-.09.164.164 0 00-.1-.03h-1.7c-.04 0-.07.01-.09.03a.098.098 0 00-.03.07 9.966 9.966 0 00.86 3.36zm10.2 7.66c.027 0 .05-.01.07-.03.02-.02.03-.043.03-.07v-1.68c0-.04-.01-.073-.03-.1a.181.181 0 00-.09-.06l-1.68-.34a.085.085 0 00-.08 0l-.08.04-1.42 1.44a8.178 8.178 0 001.66.58 8.12 8.12 0 001.62.22z","fill":"#fff"}})])
          )
        }
      }
    